<template>

    <div>

        <select v-if="!isUserFixed" class="form-select" v-model="document[field.index]" @change="onFieldSelected" @blur="onFocusOut">
            <option v-for="collaborator in model.app.collaborators"
                    :value="collaborator">{{collaborator.name}}</option>
        </select>

        <select v-else class="form-select" v-model="document[field.index]" @change="onFieldSelected" disabled>
            <option v-for="collaborator in model.app.collaborators"
                    :value="collaborator">{{collaborator.name}}</option>
        </select>

        <div v-if="field.required && !isValid" class="invalid-element">
            {{field.name}} is required
        </div>
    </div>


</template>

<script>
    import FieldUtil from "../utils/FieldUtil";
    import FormValidator from "../utils/FormValidator";
    import DataService from "../services/DataService";

    export default {
        name: 'SelectCollaborator',
        props: ['document', 'field', 'table'],
        computed: {
            isUserFixed() {
                let fieldUtil = new FieldUtil(this.field)
                return fieldUtil.isUserFixed()
            }
        },
        data() {
            return {
                model: webase.model,
                service: new DataService(this.table.id),
                isValid: true
            }
        },
        mounted() {
            if(this.isUserFixed) {
                this.document[this.field.index] = webase.managers.app.currentCollaborator()
            }

        },
        methods: {
            onFieldSelected () {
                // TODO: answer question - should we update on change or when save button is clicked
            },
            onFocusOut() {
                let validator = new FormValidator(this.table, this.document)
                this.isValid = validator.isFieldValid(this.field)

                if (!this.isValid) {
                    return
                }

                if (this.document['id'] && this.document[this.field.index]) {
                    this.service.save(this.document)
                }
            }
        }
    }
</script>

